import { Colors } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const TopUpBalanceWrapperOuter = styled.div`    
    width: 100%;
    max-width: min(90vw, 1152px);
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export const TopUpBalanceWrapper = styled.div`
    width: 100%;
    padding:  32px;
    padding-bottom: 56px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    background-color: ${p => p.theme.topup.wrapper};

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        max-width: 100vw;
        height: 100vh;
        overflow-y: scroll;
        padding: 52px 10px 40px;
        background-color: ${p => p.theme.topup.wrapperMob};
        gap: 24px;
    }
`

export const TopUpBalanceTilte = styled.div`
    font-family: Inter;
    font-size: 34px;
    font-weight: 600;
    line-height: 41px;
    letter-spacing: 0px;
    text-align: left;
    color: ${p => p.theme.topup.title};
`

export const TopUpBalanceModalTitle = styled.div`
    font-family: Inter;
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px;
    letter-spacing: -0.86px;
    color: ${Colors.galBlack100};
`

export const TopUpHint = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.galBlack47};
`

export const BundleList = styled.div`
    display: flex;
    gap: 24px;

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        flex-direction: column;
        gap: 16px;
    }
`

export const BundleItemWrapper = styled.div`
    width: 100%;
    padding: 24px;
    position: relative;
    background-color: ${p => p.theme.topup.bundle.wrapper};
    border-radius: 6px;
    display: grid;
    grid-template-rows: auto 16px 1fr 58px 16px;
`

export const BundleItemTitle = styled.div`
    font-family: Inter;
    font-size: 23px;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${p => p.theme.topup.bundle.title};
    margin-bottom: 8px;

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        margin-bottom: 4px;
    }
`

export const BundleItemSubtitle = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: ${p => p.theme.topup.bundle.subtitle};
`

export const BundleItemAmount = styled.div`
    display: flex;
    align-items: center;
    margin: 112px 0;
    font-family: Inter;
    font-size: 60px;
    font-weight: 600;
    line-height: 70px;
    letter-spacing: -0.02em;
    text-align: left;
    align-self: center;
    justify-content: center;
    color: ${p => p.theme.topup.bundle.amount};

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
        line-height: 41px;
        margin: 52px 0;
    }
`

export const BundleItemButton = styled.button`
    cursor: pointer;
    width: 100%;
    margin-bottom: 12px;
    border: none;
    outline: none;
    background-color: ${p => p.theme.topup.button};
    color: ${p => p.theme.topup.buttonText};
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;
`

export const BundleItemHint = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: center;
    color: ${p => p.theme.topup.bundle.hint};
`import { Colors } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const TopUpBalanceWrapperOuter = styled.div`    
    width: 100%;
    max-width: min(90vw, 1152px);
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export const TopUpBalanceWrapper = styled.div`
    width: 100%;
    padding:  32px;
    padding-bottom: 56px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    background-color: ${p => p.theme.topup.wrapper};

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        max-width: 100vw;
        height: 100vh;
        overflow-y: scroll;
        padding: 52px 10px 40px;
        background-color: ${p => p.theme.topup.wrapperMob};
        gap: 24px;
    }
`

export const TopUpBalanceTilte = styled.div`
    font-family: Inter;
    font-size: 34px;
    font-weight: 600;
    line-height: 41px;
    letter-spacing: 0px;
    text-align: left;
    color: ${p => p.theme.topup.title};
`

export const TopUpBalanceModalTitle = styled.div`
    font-family: Inter;
    font-size: 43px;
    font-style: normal;
    font-weight: 600;
    line-height: 51px;
    letter-spacing: -0.86px;
    color: ${Colors.galBlack100};
`

export const TopUpHint = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${Colors.galBlack47};
`

export const BundleList = styled.div`
    display: flex;
    gap: 24px;

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        flex-direction: column;
        gap: 16px;
    }
`

export const BundleItemWrapper = styled.div`
    width: 100%;
    padding: 24px;
    position: relative;
    background-color: ${p => p.theme.topup.bundle.wrapper};
    border-radius: 6px;
    display: grid;
    grid-template-rows: auto 16px 1fr 58px 16px;
`

export const BundleItemTitle = styled.div`
    font-family: Inter;
    font-size: 23px;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.02em;
    text-align: left;
    color: ${p => p.theme.topup.bundle.title};
    margin-bottom: 8px;

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        margin-bottom: 4px;
    }
`

export const BundleItemSubtitle = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: ${p => p.theme.topup.bundle.subtitle};
`

export const BundleItemAmount = styled.div`
    display: flex;
    align-items: center;
    margin: 112px 0;
    font-family: Inter;
    font-size: 60px;
    font-weight: 600;
    line-height: 70px;
    letter-spacing: -0.02em;
    text-align: left;
    align-self: center;
    justify-content: center;
    color: ${p => p.theme.topup.bundle.amount};

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
        line-height: 41px;
        margin: 52px 0;
    }
`

export const BundleItemButton = styled.button`
    cursor: pointer;
    width: 100%;
    margin-bottom: 12px;
    border: none;
    outline: none;
    background-color: ${p => p.theme.topup.button};
    color: ${p => p.theme.topup.buttonText};
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: left;
`

export const BundleItemHint = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: center;
    color: ${p => p.theme.topup.bundle.hint};
`